// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1aQMd","head":"Table_head__P2Wd_","col":"Table_col__1a8dE"};